import Person from "./scripts/Person";
// Toasitfy CSS is added with tailwindcss in index.css

import Notification from "./scripts/Notifications";

import ExampleReactComponent from "./scripts/ExampleReactComponent";
import React from "react";
import ReactDOM from "react-dom";

import { initReportHubDescriptiveStats } from "./scripts/report-hub-descriptive-stats";
import initSearchableSelects from "./scripts/searchable-selects";
import initHighlightOverloadFacultyCredits from "./scripts/highlight-overload-faculty-credits";
import initBatchwiseTimetableCascading from "./scripts/batchwise-timetable-cascading";
import initPfAssignmentCascading from "./scripts/pf-assignment-cascading";

const notification = new Notification();

function bootSearchableSelects() {
  initSearchableSelects(document);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootSearchableSelects);
} else {
  bootSearchableSelects();
}

const person1 = new Person("David");
if (document.querySelector("#render-react-example-here")) {
  ReactDOM.render(
    <ExampleReactComponent />,
    document.querySelector("#render-react-example-here")
  );
}

if (document.querySelector("[data-sas-tt-ar-stats-root]")) {
  initReportHubDescriptiveStats();
}

if (document.querySelector("[data-sas-tt-credit-highlight-controls]")) {
  initHighlightOverloadFacultyCredits();
}

if (document.querySelector("[data-sas-btt-cascading]")) {
  initBatchwiseTimetableCascading();
}

if (document.querySelector("[data-sas-pf-cascading]")) {
  initPfAssignmentCascading();
}
